import APIService from '../api.service';

export const CreditPurchaseList = (payload) => {
  return APIService.get(`/v01/credit-purchases`, {
    params: {
      ...payload
    },
  });
}

export const MakePayment = (data, config= {}) => {
    return APIService.post(`/v01/credit-purchases/make-payment`, data, config);
};

export const CreditPaymentList = (params) => {
  return APIService.get(`/v01/credit-payments`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
    },
  });
}

export const CreditPaymentItems = (id) => {
  return APIService.get(`/v01/credit-payment-items/${id}`);
}

const CreditPurchaseService = {
  CreditPurchaseList,
  MakePayment,
  CreditPaymentList,
  CreditPaymentItems
};
export default CreditPurchaseService;
